import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * The Pulso design system has no dark mode: the theme is always light, whatever the
 * OS or a previously saved preference says. The service is kept so existing callers
 * still compile; `setTheme` only (re)applies the light theme.
 */
@Injectable({
	providedIn: 'root',
})
export class ThemeService {
	private themeSubject = new BehaviorSubject<'light' | 'dark'>('light');
	theme$ = this.themeSubject.asObservable();

	constructor() {
		// Drop a dark preference saved before the redesign.
		localStorage.removeItem('theme');
	}

	setTheme(_theme?: string) {
		document.documentElement.setAttribute('data-theme', 'light');
		this.themeSubject.next('light');
	}

	getTheme(): 'light' | 'dark' {
		return 'light';
	}
}
